import * as React from 'react';

import {LocalizationProvider, MobileDateTimePicker} from "@mui/x-date-pickers";
import {AdapterDayjs} from "@mui/x-date-pickers/AdapterDayjs";
import {IconButton, Stack} from "@mui/material";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {notNull} from "../../utils/utils";
import dayjs from "dayjs";

function ButtonField(props) {
    const {
        setOpen,
        id,
        disabled,
        InputProps: {ref} = {},
        inputProps: {'aria-label': ariaLabel} = {},
    } = props;

    return (
        <IconButton
            variant="outlined"
            id={id}
            disabled={disabled}
            ref={ref}
            aria-label={ariaLabel}
            onClick={() => setOpen?.((prev) => !prev)}
        >
            <EditOutlinedIcon/>
        </IconButton>
    );
}

function ButtonDateTimePicker(props) {
    const [open, setOpen] = React.useState(false);

    return (
        <MobileDateTimePicker
            disablePast
            onAccept={props.onAccept}
            slots={{field: ButtonField, ...props.slots}}
            slotProps={{field: {setOpen}, actionBar: {actions: ['cancel', 'accept']}, tabs: {hidden: false}}}
            {...props}
            open={open}
            onClose={() => setOpen(false)}
            onOpen={() => setOpen(true)}
        />
    );
}

export default function PickerWithButtonField(props) {
    const defaultValue = notNull(props.defaultValue) ? dayjs(props.defaultValue) : null;
    const [value, setValue] = React.useState(defaultValue);

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <Stack spacing={1}>
                <ButtonDateTimePicker
                    value={value}
                    onAccept={(newValue) => {
                        props.onAccept(newValue);
                        setValue(newValue)
                    }}
                />
            </Stack>
        </LocalizationProvider>
    );
}